import { Pipe, PipeTransform } from '@angular/core';
import { QUOTE_STATUSES, QuoteStatus } from '@lockton-apps/shared/interfaces';
import { QuoteStatusMetaPipe } from './quote-status.pipe';

@Pipe({
  name: 'enquiryQuoteMeta',
  standalone: true,
})
export class EnquiryQuoteMetaPipe
  extends QuoteStatusMetaPipe<{ label: string; icon: string }>
  implements PipeTransform
{
  map = new Map<QuoteStatus, { label: string; icon: string }>([
    [
      QUOTE_STATUSES.FormInitialized,
      { label: $localize`Pending`, icon: 'more' },
    ],
    [QUOTE_STATUSES.FormSent, { label: $localize`Pending`, icon: 'more' }],
    [
      QUOTE_STATUSES.FormIncomplete,
      { label: $localize`Pending`, icon: 'more' },
    ],
    [QUOTE_STATUSES.FormComplete, { label: $localize`Pending`, icon: 'more' }],
    [QUOTE_STATUSES.OnHold, { label: $localize`Pending`, icon: 'more' }],
    [
      QUOTE_STATUSES.HealthEvaluationRequired,
      { label: $localize`Quote ready`, icon: 'quote_universal_thin' },
    ],
    [
      QUOTE_STATUSES.HealthEvaluationActive,
      { label: $localize`Quote ready`, icon: 'quote_universal_thin' },
    ],
    [
      QUOTE_STATUSES.Quoted,
      { label: $localize`Quote ready`, icon: 'quote_universal_thin' },
    ],
    [
      QUOTE_STATUSES.BrokerApproved,
      { label: $localize`Quote sent`, icon: 'quote_universal_sent_thin' },
    ],
    [
      QUOTE_STATUSES.QuoteAccepted,
      {
        label: $localize`Quote accepted`,
        icon: 'quote_universal_accepted_thin',
      },
    ],
    [
      QUOTE_STATUSES.AwaitingPayment,
      { label: $localize`Quote sent`, icon: 'quote_universal_sent_thin' },
    ],
    [
      QUOTE_STATUSES.Complete,
      { label: $localize`Quote sent`, icon: 'quote_universal_sent_thin' },
    ],
    [QUOTE_STATUSES.QuoteError, { label: $localize`Error`, icon: '' }],
  ]);

  defaultValue = { label: $localize`Unknown`, icon: 'help' };
}
